import { useCallback } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch } from 'store';
import { getCurrentUser } from 'store/selectors';
import { prevent } from 'utils/events';
import Button from 'ui/Button';

import LoginLayout from 'components/LoginLayout';

import styles from './Pages.module.scss';
import textStyles from 'ui/Text.module.scss';

interface EnterMeetProps {
  onEnter: () => void;
}

const EnterMeet: React.FC<EnterMeetProps> = ({ onEnter }) => {
  const currentUser = useSelector(getCurrentUser);
  const rootDispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation('joinPage');

  const handleLogout = useCallback(() => {
    rootDispatch({ type: 'logout' });
  }, [rootDispatch]);

  if (!currentUser) {
    return null;
  }

  let userCreds = currentUser.name;

  if (currentUser.email) {
    userCreds += ` (${currentUser.email})`;
  }

  return (
    <LoginLayout isBackButton>
      <div>
        <div className={styles.welcome}>
          <h1 className={styles.welcomeHeading}>{t('title')}</h1>
          <p className={styles.welcomeDetails}>
            <Trans
              t={t}
              i18nKey="entering"
              components={{
                b: <b />,
                a: (
                  // eslint-disable-next-line jsx-a11y/anchor-has-content
                  <a href="#logout" className={textStyles.link} onClick={prevent(handleLogout)} />
                ),
              }}
              values={{ user: userCreds }}
            />
          </p>
        </div>
      </div>
      <Button isBlock onClick={prevent(onEnter)}>
        {t('submit')}
      </Button>
    </LoginLayout>
  );
};

export default EnterMeet;
